<template>
  <div class="page">

    <div class="top">

      <div>
        <!-- Create new profile -->
        <div class="form">
          <form class="form-inline" v-on:submit.prevent="createProfile()">
            <input v-model="name" size="50" placeholder="Profile name"/>
            <button type="submit">Create new</button>
          </form>
        </div>
      </div>
    </div>

    <div class="profiles">

      <div class="top">
        <div>
          Profiles {{filteredProfiles.length}} of {{profiles.length}}
        </div>
        <div>
          <button id="refreshProfilesBtn" @click="refreshProfiles">Refresh</button>
        </div>
      </div>
      <Profile v-for="profile in filteredProfiles" :key="profile.id" :profile="profile"/>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  display: flex;
  justify-content: space-between;
}
.profiles {
  margin-top: 10px;
}
</style>

<script>
import { mapState } from 'vuex'
import Profile from '@/components/Profile.vue'

export default {
  name: 'profiles',
  components: {
    Profile
  },
  computed: {
    filteredProfiles() {
      return this.profiles
    },
    ...mapState([
      'debugMode',
      'api',
      'profiles'
    ])
  },
  methods: {
    refreshProfiles () {
      this.$store.dispatch('loadProfiles')
    },
    createProfile () {
      if (!this.name) return
      this.$store.dispatch('createProfile', {
        name: this.name
      })
      this.name = ''
    }
  },
  mounted () {
    // this.refreshProfiles()
  },
  data () {    
    return {
      name: ''
    }
  }
}
</script>
